(function () {
  'use strict';

  const TOUCH_THRESHOLD_PX = 50;
  const AXIS_VIOLATION_PX = 10;

  function init() {
    const roots = document.querySelectorAll('[data-gallery-root]');
    roots.forEach(initGallery);
  }

  function initGallery(root) {
    const elements = collectElements(root);
    const state = {
      currentIndex: 0,
      slideCount: elements.slides.length,
      touchStartX: 0,
      touchStartY: 0,
      swipeBlocked: false,
    };

    if (state.slideCount <= 1) {
      return;
    }

    syncState(elements, state);

    root.addEventListener('click', function (event) {
      const videoTrigger = event.target.closest('[data-video-trigger]');
      if (videoTrigger && root.contains(videoTrigger)) {
        if (window.PdpVideoModal) {
          window.PdpVideoModal.open(videoTrigger);
        }
        return;
      }

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb && root.contains(thumb)) {
        const index = parseInt(thumb.dataset.slideIndex, 10);
        goToSlide(elements, state, index);
        return;
      }

      const prev = event.target.closest('[data-gallery-prev]');
      if (prev && root.contains(prev)) {
        goToSlide(elements, state, state.currentIndex - 1);
        return;
      }

      const next = event.target.closest('[data-gallery-next]');
      if (next && root.contains(next)) {
        goToSlide(elements, state, state.currentIndex + 1);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        goToSlide(elements, state, state.currentIndex - 1);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        goToSlide(elements, state, state.currentIndex + 1);
        event.preventDefault();
      }
    });

    elements.track.addEventListener('touchstart', function (event) {
      state.touchStartX = event.touches[0].clientX;
      state.touchStartY = event.touches[0].clientY;
      state.swipeBlocked = false;
    }, { passive: true });

    elements.track.addEventListener('touchmove', function (event) {
      if (state.swipeBlocked) return;
      const deltaX = event.touches[0].clientX - state.touchStartX;
      const deltaY = event.touches[0].clientY - state.touchStartY;
      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > AXIS_VIOLATION_PX) {
        state.swipeBlocked = true;
      }
    }, { passive: true });

    elements.track.addEventListener('touchend', function (event) {
      if (state.swipeBlocked) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - state.touchStartX;
      if (Math.abs(deltaX) < TOUCH_THRESHOLD_PX) return;
      const direction = deltaX < 0 ? 1 : -1;
      goToSlide(elements, state, state.currentIndex + direction);
    });
  }

  function collectElements(root) {
    return {
      root: root,
      track: root.querySelector('[data-gallery-track]'),
      thumbs: Array.from(root.querySelectorAll('[data-gallery-thumb]')),
      dots: Array.from(root.querySelectorAll('[data-gallery-dot]')),
      slides: Array.from(root.querySelectorAll('.c-pdp-gallery__slide')),
      prevBtn: root.querySelector('[data-gallery-prev]'),
      nextBtn: root.querySelector('[data-gallery-next]'),
    };
  }

  function goToSlide(elements, state, targetIndex) {
    const clamped = Math.max(0, Math.min(targetIndex, state.slideCount - 1));
    if (clamped === state.currentIndex) return;
    state.currentIndex = clamped;
    syncState(elements, state);
  }

  function syncState(elements, state) {
    elements.track.style.setProperty('--current-index', String(state.currentIndex));

    elements.thumbs.forEach(function (thumb) {
      const idx = parseInt(thumb.dataset.slideIndex, 10);
      const isActive = idx === state.currentIndex;
      thumb.dataset.active = isActive ? 'true' : 'false';
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    elements.dots.forEach(function (dot) {
      const idx = parseInt(dot.dataset.slideIndex, 10);
      dot.dataset.active = idx === state.currentIndex ? 'true' : 'false';
    });

    elements.slides.forEach(function (slide) {
      const idx = parseInt(slide.dataset.slideIndex, 10);
      slide.setAttribute('aria-hidden', idx === state.currentIndex ? 'false' : 'true');
    });

    if (elements.prevBtn) {
      elements.prevBtn.disabled = state.currentIndex === 0;
    }
    if (elements.nextBtn) {
      elements.nextBtn.disabled = state.currentIndex === state.slideCount - 1;
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
